
 export const global = { 
    fs : "false",
    dbVersion:(parseInt(localStorage.getItem('dbVersion')) ? parseInt(localStorage.getItem('dbVersion')) : 0),
}

 